import { render, staticRenderFns } from "./REPOST.vue?vue&type=template&id=18d19432"
import script from "./REPOST.vue?vue&type=script&lang=js"
export * from "./REPOST.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports